import { WordRange } from "../types";

export function isInRange(range: WordRange, index: number): boolean {
  const { startPosition, endPosition } = range;
  return startPosition <= index && endPosition >= index;
}
